import { ConfigurationMainModel, ConfigurationDefaultModel, configurationDefaults } from 'franke-trough-dependencies';

export const compareResetDataAndSetDefaults = (
  itemsToReset: string[],
  configuration?: ConfigurationMainModel, 
  defaults?: ConfigurationDefaultModel
): ConfigurationMainModel | undefined => {
  if (configuration && defaults) {
    Object.keys(configuration).forEach(keys => {
      const items = configuration[keys];
      const current = defaults && defaults[keys];
      if (itemsToReset) {
        itemsToReset.forEach(item => {
          switch (item) {
            case 'qty':
              configuration[keys].qty = configurationDefaults.selectedTrough.qty;
              break;
            case 'cornerDesign':
              configuration[keys].cornerDesign = configurationDefaults.washBasinDimension.cornerDesign.default;
              configuration[keys].cornerDesignPosition =  configurationDefaults.washBasinDimension.cornerDesignPosition.default;
              break;
            case 'console':
              configuration[keys].selection = configurationDefaults.assemblyAccessories.selection.default;
              configuration[keys].console = configurationDefaults.assemblyAccessories.console.default;
              break;
            case 'apron':
              configuration[keys].apron = 'without';
              configuration[keys].restorablePlateDimensions = null;
              break;
            default:
              if (items[item]) {
                configuration[keys][item] = current[item].default;
              }
          }
        });
      }
    });
    return configuration;
  }
  return;
};